<!-- 
System: GIGSTIMER
Developer(s): Menahil, Neha, Shoaib, Hamza , Ali Haider
Date: 
Organization: Programmer Force
Purpose: Allow user to login to his/her gigstimer account
-->
<template>
  <!-- Render form-base-layout component to pass input fields -->
  <FormLayout>
    <!-- Pass form slot to component(FormLayout) -->
    <template v-slot:form>
      <!-- snackbar -->
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />

      <!--Offline Mode Top Bar-->
      <v-app-bar
        v-if="!getOnlineStatus"
        app
        elevation="0"
        :color="'white'"
        :height="isExtension ? 42 : 46"
      >
        <v-overlay
          :value="!getOnlineStatus"
          v-if="!getOnlineStatus"
          opacity="1"
          color="#FFF5F7"
          class="text-center"
        >
          <span class="red--text text--darken-1 font-weight-bold">
            <v-icon class="red--text text--darken-1">
              mdi-close-circle-outline
            </v-icon>

            Offline Mode !</span
          >
          <span class="black--text"> No internet Connection </span>
        </v-overlay>
      </v-app-bar>

      <!-- card -->
      <v-card
        :width="
          $vuetify.breakpoint.md ||
          $vuetify.breakpoint.sm ||
          $vuetify.breakpoint.xs
            ? '100%'
            : $vuetify.breakpoint.xl
            ? '60%'
            : '60%'
        "
        elevation="0"
        :class="
          $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? 'mx-auto' : ''
        "
        :disabled="getOnlineStatus == false"
      >
        <!--Title-->
        <v-card-title :class="$vuetify.breakpoint.xs ? 'mx-auto mb-5' : 'mx-8'">
          <p id="login-card-heading" class="font-weight-bold card-heading">
            Login
          </p>
        </v-card-title>
        <!-- Form -->
        <v-card-text>
          <v-form
            id="login-form"
            ref="form"
            v-model="valid"
            lazy-validation
            :class="
              $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                ? 'mx-auto'
                : 'mb-16 form mx-8'
            "
            autocomplete="off"
          >
            <!-- Email Input Field -->
            <label>Email Address *</label>
            <v-text-field
              color="#dcd8f3"
              id="login-email-input"
              outlined
              v-model="email"
              :rules="emailRules"
            ></v-text-field>
            <!-- Password Input Field -->
            <label class="mb-n3">Password *</label>
            <v-text-field
              color="#dcd8f3"
              id="login-password-input"
              outlined
              v-model="password"
              :rules="required"
              :append-icon="visible ? 'mdi-eye' : 'mdi-eye-off'"
              :type="visible ? 'text' : 'password'"
              @click:append="visible = !visible"
              @keydown.enter="login()"
              class="mb-n7"
            ></v-text-field>
            <!-- Remember Me Checkbox -->
            <v-row align="center" class="mx-1">
              <v-checkbox
                id="login-remember-checkbox"
                color="#2a206a"
                label="Remember Me"
                class="subtitle-2"
              ></v-checkbox>
              <!-- Forgot Password Page Redirection Text -->
              <v-spacer></v-spacer>
              <router-link
                id="forget-password-link"
                to="/forget-password"
                class="text-decoration-none subtitle-2 success-text"
                :class="
                  $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                    ? 'float-left my-2'
                    : 'float-right'
                "
                >Forgot Password?</router-link
              >
            </v-row>
            <!-- Login button -->
            <v-btn
              :disabled="!valid"
              id="login-btn"
              :class="
                $vuetify.breakpoint.xs
                  ? 'subtitle-1'
                  : 'title submit-btn-height-md '
              "
              :x-large="$vuetify.breakpoint.md || $vuetify.breakpoint.lg"
              :medium="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
              width="60%"
              class="btn-success white--text mx-auto my-1 text-capitalize mt-5 align-center d-flex"
              @click="login"
              :loading="loader"
            >
              Login
            </v-btn>
            <vue-recaptcha
              v-if="isExtension || !$vuetify.breakpoint.xs"
              :loadRecaptchaScript="true"
              ref="recaptcha"
              @verify="onCaptchaVerified"
              @expired="onCaptchaExpired"
              size="invisible"
              :sitekey="sitekey"
              class="overflow-auto"
            >
            </vue-recaptcha>
            <!--Redirect to Signup -->
            <p class="mt-1 body-2 ml-1 justify-center align-center d-flex">
              Don't have an account?
              <router-link
                id="signup-link"
                to="signup"
                class="text-decoration-none success-text ml-2"
                >Sign Up</router-link
              >
            </p>
          </v-form>
        </v-card-text>
      </v-card>
    </template>
  </FormLayout>
</template>

<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { emailRules, required } from "@/validations/validations.js";
import VueRecaptcha from "vue-recaptcha";
import FormLayout from "../Layouts/FormLayout";
import { baseURL } from "@/assets/js/urls";
export default {
  name: "login",
  components: {
    FormLayout,
    "vue-recaptcha": VueRecaptcha,
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  computed: {
    ...mapGetters(["getCompanies", "getOnlineStatus"]),
  },
  mixins: [snackbarMixin],
  data() {
    return {
      sitekey: baseURL.CAPTCHA_KEY,
      loader: false,
      visible: false,
      valid: false,
      password: null,
      email: null,
      emailRules: emailRules,
      required: required,
      token1: null,
    };
  },

  methods: {
    getLoginToken(token) {
      console.log("function called after login", token);
    },
    onCaptchaVerified(recaptchaToken) {
      if (this.email && this.password) {
        let user = {
          email: this.email.toLowerCase(),
          password: this.password,
          token: recaptchaToken,
        };
        this.valid = true;
        this.loader = true;
        this.$store.commit("setTasksSkeletonLoader", true);
        this.$store.commit("setCalendarTasksSkeletonLoader", true);
        this.$store
          .dispatch("userLogin", user)
          .then(() => {
            localStorage.setItem("user", user);
            this.$store.dispatch("fetchCompanies").then(() => {
              this.$vuetify.breakpoint.xs && !this.isExtension
                ? this.$router.push({
                    name: "mobileTasks",
                  })
                : this.$router.push({
                    name: "task",
                  });
            });
          })
          .catch((error) => {
            this.loader = false;
            this.$refs.recaptcha.reset();
            if (error && error.response && error.response.status == 422) {
              if (error.response.data.errors.email) {
                this.openSnackbar(true, error.response.data.errors.email[0]);
              }
            }
          });
      } else {
        this.valid = false;
        this.openSnackbar(true, "Enter your credentials to proceed");
      }
    },
    // User login
    login() {
      this.$vuetify.breakpoint.xs && !this.isExtension
        ? this.loginFunction()
        : this.$refs.recaptcha.execute();
    },
    onCaptchaExpired: function() {
      this.$refs.recaptcha.reset();
    },
    loginFunction() {
      if (this.email && this.password) {
        let user = {
          email: this.email.toLowerCase(),
          password: this.password,
        };
        this.valid = true;
        this.loader = true;
        this.$store.commit("setTasksSkeletonLoader", true);
        this.$store.commit("setCalendarTasksSkeletonLoader", true);
        this.$store
          .dispatch("userLogin", user)
          .then(() => {
            localStorage.setItem("user", user);
            this.$store.dispatch("fetchCompanies").then(() => {
              this.token1 = JSON.parse(localStorage.getItem("token"));
              this.getLoginToken(this.token1);
              this.$router.push({
                name: "mobileTasks",
              });
            });
          })
          .catch((error) => {
            this.loader = false;
            if (error && error.response && error.response.status == 422) {
              if (error.response.data.errors.email) {
                this.openSnackbar(true, error.response.data.errors.email[0]);
              }
            }
          });
      } else {
        this.valid = false;
        this.openSnackbar(true, "Enter your credentials to proceed");
      }
    },
  },
  mounted() {
    // If user session has not expired yet then redirect the user to dashboard
    // Else route to login
    if (localStorage.getItem("user") && localStorage.getItem("token")) {
      this.$vuetify.breakpoint.xs && !this.isExtension
        ? this.$router.push({
            name: "mobileTasks",
          })
        : this.$router.push({
            name: "task",
          });
    }
  },
};
</script>
